module.exports = __webpack_public_path__ + "static/img/数字化治理.9199c30.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/数字化治理.png
// module id = ZtdE
// module chunks = 0